export default __webpack_public_path__ + "static/media/ashley.d85e5217.png";